import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const BidsReviewAndEditingModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=ihodHMyztgk&feature=youtu.be&ab_channel=apadua" />
);

export default BidsReviewAndEditingModal;
